<template>
  <div>
    <top-nav></top-nav>
    <div class="center_container">
      <div class="crumb">健身学习课程 / 课程详情</div>
      <div class="display_flex c_title">
        <div>30分钟燃脂课程</div>
        <el-button type="primary"><i class="el-icon-star-on" style="color:#F4C41D;margin-right: 12px"></i>收藏</el-button>
      </div>
      <video class="c_video" controls></video>
      <div class="c_bot">
        <div class="b_left">
          <div class="b_title">评论</div>
          <div class="comment_list">
            <div v-for="item in 6" :key="item" class="comment_item">
              <div class="display_flex i_top">
                <div>会员23987864</div>
                <div class="i_time">2023-07-24 17:57:53</div>
              </div>
              <div class="i_con">
                非常好的场馆非常好的场馆非常好的场馆非常好的场馆非常好的场馆非常好的场馆，非常好的场馆非常好的场馆非常好的场馆非常好的场馆，非常好的场馆非常好的场馆非常好的场馆非常好的场馆非常好的场馆，非常
                好的场馆非常好的场馆，非常好的场馆非常好的场馆。
              </div>
            </div>
          </div>
          <div class="display_flex" style="justify-content: center">
            <el-pagination
                :total="100"
                background
                layout="prev, pager, next">
            </el-pagination>
          </div>
        </div>
        <div class="b_right">
          <div class="b_title">相关课程</div>
          <div class="course_list">
            <div v-for="item in courseList" :key="item.id" class="s_con">
              <div class="s_img">
                <img :src="require(`../../assets/image/course/c${item.id}.png`)" alt="">
              </div>
              <div class="s_info">
                <div>
                  <div class="text_overflow s_name">{{ item.name }}</div>
                  <div>发布时间：{{ item.date }}</div>
                  <div class="s_type">{{ item.type }}</div>
                </div>
                <br>
                <el-button class="s_btn" type="primary">立即观看</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bot-nav></bot-nav>
  </div>
</template>

<script>
export default {
  name: "courseDetail",
  data () {
    return {
      courseList: [
        { id: 1, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
        { id: 2, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
        { id: 3, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' },
        { id: 4, name: '30分钟燃脂课程', date: '2023-08-23 09:00', type: '家庭健身' }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.center_container {
  padding-bottom: 47px;

  .c_title {
    padding-bottom: 25px;
    font-weight: 700;
    font-size: 48px;
  }

  .c_video {
    width: 100%;
    height: 800px;
  }

  .c_bot {
    display: flex;
    margin-top: 42px;

    .b_title {
      font-weight: 500;
      font-size: 24px;
      color: #0058A6;
    }

    .b_left {
      width: 65%;
      border-right: 1px solid #DCDCDC;
      padding-right: 25px;
      margin-right: 25px;
    }

    .b_right {
      width: 35%;

      .course_list {
        .s_con {
          display: flex;
          padding: 29px 0;
          border-bottom: 1px solid #DCDCDC;

          .s_img {
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .s_info {
            font-size: 18px;
            padding-left: 25px;
            white-space: nowrap;

            .s_name {
              font-weight: 700;
              font-size: 24px;
              margin-bottom: 24px;
            }

            .s_type {
              display: inline-block;
              padding: 8px 14px;
              margin-top: 8px;
              background: #0058a626;
              font-size: 14px;
              color: #0058A6;
            }
          }
        }
      }
    }
  }
}
</style>
